import React, { useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import { HemaDateFormat } from "../helpers/commonHelper";
import {
  HemaValue,
  HemaHeadingWithSubText,
  HemaLabel
} from "../utils";
import { getSiteDocumentsAction } from '../Actions/orders';
import { useSelector } from 'react-redux';

const Documents = () => {
  const { activeSite, site } = useSelector((state) => state);

  const fetchDocuments = () => {
    if (activeSite || localStorage.getItem('portal-active-site-id')) {
      getSiteDocumentsAction(
        activeSite || localStorage.getItem('portal-active-site-id')
      );
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [activeSite, localStorage.getItem('portal-active-site-id')]);

  // Add event listener for site changes
  useEffect(() => {
    const handleSiteChange = (event) => {
      fetchDocuments();
    };

    window.addEventListener('siteChanged', handleSiteChange);

    return () => {
      window.removeEventListener('siteChanged', handleSiteChange);
    };
  }, []);

  const handleDownload = async (fileUrl, customFileName) => {
    try {
      // Fetch the file data from the URL
      const response = await fetch(fileUrl);
      
      if (!response.ok) {
        throw new Error('Failed to fetch file');
      }

      // Convert the response to a Blob
      const blob = await response.blob();

      // Create a temporary link element
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = customFileName; // Set the custom file name

      // Append the link to the body
      document.body.appendChild(link);
      link.click(); // Trigger the download

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href); // Release memory
    } catch (error) {
      console.error('Download failed', error);
    }
  };
  //console.log('siteDocuments',site)
  return (
    <div className="max-w-[1540px] " >
      <h2>Documents</h2>
      <div className="flex items-center mb-[100px]"  style={
      {
        display: 'flex',
        justifyContent: 'center', /* Horizontally center */
        alignItems: 'center',    /* Vertically center */
       // height: 100vh,          /* Make the container fill the viewport height */
        flexDirection: 'column'  /* Stack the inner divs vertically */
      }
    }>


        {true && (
          <DataTable
            data={site?.documents || []}
            columns={[
              {
                width: '50%',
                name: <HemaValue text="File" className="text-xl font-normal " color="text-[#000000]" />,

                selector: (row) => (
                  <button onClick={()=>handleDownload(row?.file?.storageUrl,row?.file?.friendlyName)}>
                    <HemaValue className="font-normal text-m decoration-[#605DAF] " color="text-[#605DAF]" text={row?.file?.friendlyName} />
                  </button>
                ),
              },
              {
                width: '25%',
                name: <HemaValue text={'Date Created'} className="text-m font-normal " color="text-[#000000]" />,
                selector: (row) => <HemaValue className="text-xs" text={HemaDateFormat(row?.createdUtc)} />,
              },
              {
                width: '25%',
                name: <HemaValue text={'Record Owner'} className="text-m font-normal " color="text-[#000000]" />,
                selector: (row) => <HemaValue className="text-xs" text={row?.owner?.name || 'NA'} />,
              },
            ]}
          />
        )}
      </div>
    </div>
  )
}


export default Documents;